import { AppBar, Button, Container, Toolbar, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useHistory } from 'react-router-dom';

const Footer = ({ linkData }) => {
  const history = useHistory();
  return (
    <AppBar
      position="static"
      sx={{ top: 'auto', bottom: 0, left: 0, right: 0 }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              gap: '8px',
            }}
          >
            {linkData.map(({ name, to }) => (
              <Button
                variant="text"
                size="small"
                onClick={() => history.push(to)}
                key={name}
              >
                {name}
              </Button>
            ))}
          </Box>
          <Typography variant="body2" color="GrayText">
            Trademark and Copyright 2021 from Circulus Inc. All rights reserved.
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Footer;
